import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useState, useEffect } from 'react';

const FormTextField = ({ label, required = false, placeholder, multiline = false, value, onChange }) => (
    <TextField
        label={label}
        placeholder={placeholder}
        fullWidth
        required={required}
        multiline={multiline}
        rows={multiline ? 3 : 1}
        value={value}
        onChange={onChange}
        sx={{ marginBottom: '1rem' }}
    />
);

const FormAutocomplete = ({ label, options, required = false, value, onChange }) => (
    <Autocomplete
        options={options}
        value={value}
        onChange={onChange}
        renderInput={(params) => <TextField {...params} label={label} required={required} />}
        sx={{ marginBottom: '1rem' }}
    />
);

const FormDatePicker = ({ label, value, onChange }) => (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
            label={label}
            value={value}
            onChange={onChange}
            renderInput={(params) => <TextField {...params} fullWidth />}
            sx={{ marginBottom: '1rem' }}
        />
    </LocalizationProvider>
);


const formConfigs = {
    "gate pass": [
        { type: 'text', label: 'Unit' },
        { type: 'text', label: 'First Name' },
        { type: 'text', label: 'Last Name' },
        { type: 'text', label: 'Organization', placeholder: 'Optional' },
        { type: 'text', label: 'Description', multiline: true },
        { type: 'date', label: 'Start Date' },
        { type: 'date', label: 'End Date' },
        { type: 'autocomplete', label: 'Status', options: ['Pending', 'In-Progress', 'Completed', 'Rejected'] },
    ],
    "request": [
        { type: 'text', label: 'Unit' },
        { type: 'autocomplete', label: 'Priority', options: ['High', 'Medium', 'Low'] },
        { type: 'text', label: 'Requested By' },
        { type: 'text', label: 'Managed By' },
        { type: 'text', label: 'Assignees' },
        { type: 'autocomplete', label: 'Type', options: ['Maintenance', 'Package', 'Change Request', 'Complaint', 'Amenity Booking', 'Custom', 'Payment', 'Service'] },
        { type: 'text', label: 'Description', multiline: true },
    ],
    "work permit": [
        { type: 'text', label: 'Unit' },
        { type: 'text', label: 'Filed By' },
        { type: 'text', label: 'Service Provider' },
        { type: 'autocomplete', label: 'Work Category', options: ['Wifi', 'Plumbing', 'Electrical', 'Cleaning', 'Renovation', 'Painting'] },
        { type: 'text', label: 'Work Description', multiline: true },
        { type: 'date', label: 'Start Date' },
        { type: 'date', label: 'End Date' },
    ],
};

const ChatViewForm = ({ formType = 'request', onClose, onConfirm, onCancel }) => {
    const fields = formConfigs[formType] || [];

    useEffect(() => {
        console.log(`Form type changed to: ${formType}`);
    }, [formType]);

    // Store field values
    const [formData, setFormData] = useState({});

    useEffect(() => {
        // Reset when formType changes
        setFormData({});
    }, [formType]);

    const handleChange = (label, value) => {
        setFormData(prev => ({ ...prev, [label]: value }));
    };

    return (
        <div className="chat-view-form flex flex-col h-full justify-between p-4 overflow-y-auto">
            {/* Top form content */}
            <div>
                <div className="flex flex-row items-center mb-4">
                    <i
                        className="fas fa-caret-left mr-3 text-[20px] cursor-pointer"
                        onClick={onClose}
                    ></i>
                    <h2 className="text-2xl text-black">Request Form</h2>
                </div>
                <p className="mb-6">
                    Please confirm the details of your form to request a service. Fill up any incomplete details.
                </p>

                {/* Dynamic fields */}
                <div className="flex flex-col">
                    {fields.map((field, idx) => {
                        if (field.type === 'text')
                            return (
                                <FormTextField
                                    key={idx}
                                    {...field}
                                    value={formData[field.label] || ""}
                                    onChange={(e) => handleChange(field.label, e.target.value)}
                                />
                            );

                        if (field.type === 'autocomplete')
                            return (
                                <FormAutocomplete
                                    key={idx}
                                    {...field}
                                    value={formData[field.label] || null}
                                    onChange={(e, newValue) => handleChange(field.label, newValue)}
                                />
                            );

                        if (field.type === 'date')
                            return (
                                <FormDatePicker
                                    key={idx}
                                    {...field}
                                    value={formData[field.label] || null}
                                    onChange={(newValue) => handleChange(field.label, newValue)}
                                />
                            );

                        return null;
                    })}
                </div>
            </div>

            {/* Bottom confirm button */}
            <div className="mt-4">
                <div
                    className="text-white bg-[#445485] font-poppins text-center p-3 w-full rounded-lg cursor-pointer"
                    onClick={() => onConfirm(formData)}
                >
                    Confirm
                </div>
                <div
                    className="mt-2 text-white bg-[#000000] font-poppins text-center p-3 w-full rounded-lg cursor-pointer"
                    onClick={onCancel}
                >
                    Cancel
                </div>
            </div>
        </div>
    );
};

export default ChatViewForm;
